export enum DeleteConfirmResults {
  OK,
  CANCEL
}
